import { render, staticRenderFns } from "./tim.vue?vue&type=template&id=67e8b11f&"
import script from "./tim.vue?vue&type=script&lang=js&"
export * from "./tim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports